const PayoutTransactions = () => {
	return <div>PayoutTransactions</div>;
};

export default PayoutTransactions;
